import { List } from '@tamagui/lucide-icons';
import { Page } from '@unistocks/components/page/page';
import { CreatePortfolioForm } from '@unistocks/features/portfolios/components/forms/create-portfolio-form';
import { WATCHLIST } from '@unistocks/features/portfolios/portfolio-type';
import { useWatchlistsCreateMutation } from '@unistocks/proxy/axios-client/WatchlistsQuery';
import { t } from '@unistocks/shared/localization/index.ts';
import { useRouter } from 'expo-router';
import { Keyboard } from 'react-native';

export const CreateWatchlist: React.FC = () => {
  const router = useRouter();

  const { mutateAsync: createWatchlist } = useWatchlistsCreateMutation({
    onMutate: () => {
      Keyboard.dismiss();
    },
    onSuccess: ({ id }) => {
      router.replace({ pathname: '/(tabs)/watchlists/[id]', params: { id } });
    }
  });

  return (
    <Page size={'small'}>
      <Page.ScrollView
        headerLogo={false}
        headerTitle={t('::Menu:Watchlists:Create')}
        breadcrumbs={[
          {
            key: 'watchlists',
            href: { pathname: '/(tabs)/watchlists' },
            name: t('::Menu:Watchlists'),
            rootPathName: 'watchlists',
            Icon: props => <List {...props} />
          }
        ]}
      >
        <Page.Content>
          <CreatePortfolioForm type={WATCHLIST} onSubmit={createWatchlist} />
        </Page.Content>
      </Page.ScrollView>
    </Page>
  );
};

CreateWatchlist.displayName = 'CreateWatchlist';
